import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpGenericService } from '@app/@core/services';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService extends HttpGenericService {
  constructor(httpClient: HttpClient) {
    super(httpClient, environment.apiUrl, 'user');
  }
}
